import _ from 'lodash';
import {
    containerFluid,
    defaultFont,
    primaryColor,
    defaultBoxShadow,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    whiteColor,
    grayColor,
} from '../global';

const headerStyle = (theme) => ({
    appBar: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        marginBottom: '0',
        position: 'absolute',
        width: '100%',
        paddingTop: '10px',
        zIndex: '1029',
        color: grayColor,
        border: '0',
        borderRadius: '3px',
        padding: '10px 0',
        transition: 'all 150ms ease 0s',
        minHeight: '50px',
        display: 'block',
        borderBottom: '1px solid #ddd',
    },
    userAppBar: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        marginBottom: '0',
        position: 'absolute',
        width: '100%',
        paddingTop: '10px',
        zIndex: '1029',
        color: grayColor,
        border: '0',
        borderRadius: '3px',
        padding: '10px 0',
        transition: 'all 150ms ease 0s',
        minHeight: '50px',
        display: 'contents',
        // borderBottom: '1px solid #ddd',
    },
    userText: {
        background: 'linear-gradient(to top, #03418e 30%, #31ccff 95%)',
        textShadow: (props) => (props?.customColorEvent?.event_name_text_color
            ? `0 0 ${props?.customColorEvent?.event_name_text_color}, -1px 0 white, 0 -1px white, 0 1px white, 1px 1px white, -1px -1px white, -1px 1px white, 1px 1px white`
            : `0 0 ${infoColor}, -1px 0 white, 0 -1px white, 0 1px white, 1px 1px white, -1px -1px white, -1px 1px white, 1px 1px white`),
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
    },
    noImageText: {
        margin: 'auto',
        textAlign: 'center',
        color: '#2089ae',
        fontSize: '60px',
        paddingBottom: '5px',
        [theme.breakpoints.down('md')]: {
            fontSize: '48px',
        },
        // background: 'linear-gradient(to top, #03418e 30%, #31ccff 95%)',
        // textShadow: `0 0 ${infoColor}, -1px 0 white, 0 -1px white, 0 1px white, 1px 1px white, -1px -1px white, -1px 1px white, 1px 1px white`,
        // '-webkit-background-clip': 'text',
        // '-webkit-text-fill-color': 'transparent',
        [theme.breakpoints.up('md')]: { paddingLeft: '260px' },
    },
    container: {
        ...containerFluid,
        minHeight: '50px',
    },
    flex: {
        flex: 1,
    },
    title: {
        ...defaultFont,
        letterSpacing: 'unset',
        lineHeight: '30px',
        fontSize: '18px',
        borderRadius: '3px',
        textTransform: 'none',
        color: 'inherit',
        margin: '0',
        '&:hover,&:focus': {
            background: 'transparent',
        },
    },
    appResponsive: {
        top: '8px',
    },
    primary: {
        backgroundColor: primaryColor,
        color: whiteColor,
        ...defaultBoxShadow,
    },
    info: {
        backgroundColor: infoColor,
        color: whiteColor,
        ...defaultBoxShadow,
    },
    success: {
        backgroundColor: successColor,
        color: whiteColor,
        ...defaultBoxShadow,
    },
    warning: {
        backgroundColor: warningColor,
        color: whiteColor,
        ...defaultBoxShadow,
    },
    danger: {
        backgroundColor: dangerColor,
        color: whiteColor,
        ...defaultBoxShadow,
    },
});

export default headerStyle;
